import { EVENT_STATUS } from '../Consts';
import { getRouteEventSettings } from '../route';

export const parseQueryString = (urlSearch, urlHash) => {
  const result = {};

  const trim = (str, chars) => {
    for (const i in str) {
      const char = str[i];
      if (! chars.includes(char)) {
        return str.slice(i);
      }
    }

    return '';
  }

  [urlSearch, urlHash].forEach((value) => {
    const params = new URLSearchParams(trim(value, ['?', '/', '#']).replace(new RegExp('^[#?]+', 'g'), ''));
    params.forEach((value, key) => {
        result[key] = value;
    });
  });

  return result;
}

export const getResponseFromError = (error) => {
  if (error.response) {
    return JSON.parse(error.response?.request?.response);
  }

  return undefined;
}

export const prepareNumberValue = (value) => {
  value = value.toString().replace(',', '.');

  if (value.indexOf('.') >= 0) {
    return value.substring(0, value.indexOf('.') + 3);
  }

  value = Number(value);
  if (isNaN(value)) {
    return 0;
  }

  return value;
}

export const prepareString = (string) => {
  const replace = {
    ' ':' ',
    ' ':' ',
    ' ':' ',
    ' ':' ',
    ' ':' ',
    ' ':' ',
    ' ':' ',
    ' ':' ',
    ' ':' ',
    ' ':' ',
    ' ':' ',
    ' ':' ',
    ' ':' ',
    ' ':' ',
    'ﾠ':' ',
    'ㅤ':' ',
    'ᅠ':' ',
  };

  string = string.toString().replace(/\p{Zs}/gu, ' ');
  Object.keys(replace).forEach((key) => {
    string = string.split(key).join(replace[key]);
  });

  // 🚀ㅤ=>🚀
  return string.trim();
}

export const checkEventStatusArchive = (context, event) => {
  if (event.status === EVENT_STATUS.ARCHIVED) {
    context.confirm(
      context.lang().getKey('app', 'create_payment_confirm_for_archived'),
      (result) => {
        if (!result) {
          context.router.push(...getRouteEventSettings(event.id));
        }
      },
      context.lang().getKey('app', 'create_items_confirm_button_label_ok'),
      context.lang().getKey('app', 'create_items_confirm_button_label_settings')
    );
    return true;
  }

  return false;
}

export const checkEventStatusForCreatePayment = (context, event) => {
  if (checkEventStatusArchive(context, event)) {
    return false;
  } else if (event.status === EVENT_STATUS.REPAYMENTS) {
    context.confirm(
      context.lang().getKey('app', 'create_payment_confirm_for_repayments'),
      (result) => {
        if (!result) {
          context.router.push(...getRouteEventSettings(event.id));
        }
      },
      context.lang().getKey('app', 'create_items_confirm_button_label_ok'),
      context.lang().getKey('app', 'create_items_confirm_button_label_settings')
    );
    return false;
  }

  return true;
}

export const checkEventStatusForCreateRepayment = (context, event) => {
  if (checkEventStatusArchive(context, event)) {
    return false;
  } else if (event.status === EVENT_STATUS.PAYMENTS) {
    context.confirm(
      context.lang().getKey('app', 'create_payment_confirm_for_payments'),
      (result) => {
        if (!result) {
          context.router.push(...getRouteEventSettings(event.id));
        }
      },
      context.lang().getKey('app', 'create_items_confirm_button_label_ok'),
      context.lang().getKey('app', 'create_items_confirm_button_label_settings')
    );
    return false;
  }

  return true;
}